





























































































































































































































































import { isNullOrUndefined, validateEmail } from '@/functions';
import { http } from '@/services';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AddEmployeeDialog extends Vue {
  @Prop()
  protected selectedEmployee?: any;
  protected newEmployee: any = {
    name: '',
    birthDate: new Date(Date.now()).toISOString().slice(0, 10),
    cpf: '',
    rg: '',
    maritalStatus: 2,
    matrimonialRegime: 0,
    department: 0,
    companyRole: 0,
    user: {
      login: '',
      password: '',
      roles: [],
    },
  };
  protected showMenu: boolean = false;
  protected showPassword: boolean = false;
  protected isValid: boolean = false;
  protected isShowing: boolean = false;
  protected step: number = 1;
  protected rules = {
    name: [
      (name: string) =>
        (name.trim().length >= 3 && name.trim().length < 120) ||
        'O nome é requerido!',
      (name: string) =>
        (!!name.trim().match(/^[a-zA-Z]{3,}(\s[a-zA-Z]+)*$/)) ||
        'O nome deve conter apenas caracteres.',
    ],
    rg: [
      (rg: string) =>
        (isNullOrUndefined(rg) || rg.trim().length === 0 || rg.trim().length <= 15) ||
        'O R.G. deve possuir no máximo 15 caracteres.',
    ],
    cpf: [
      (cpf: string) =>
        (cpf.trim().length === 11) ||
        'Por favor, insira um CPF válido',
    ],
    birthDate: [
      (birthDate: string) =>
        (new Date(birthDate) <= new Date(Date.now())) ||
        'A data de nascimento deve ser inferior à data atual.',
    ],
    nonNullType: [
      (type: number) =>
        type !== 0 ||
        'Por favor, selecione o tipo da empresa.',
    ],
    login: [
      (login: string) =>
        login.trim().length > 0 ||
        'O e-mail de usuário é requerido.',
      (login: string) =>
        validateEmail(login) ||
        'Por favor, informe um e-mail válido.',
    ],
    password: [
      (password: string) =>
        password.trim().length >= 8 ||
        'Por favor, informe uma senha de pelo menos oito caracteres.',
    ],
    roles: [
      (roles: Array<any>) =>
        roles.length > 0 ||
        'Selecione pelo menos um papel para o usuário.',
    ],
  };

  protected maritalStatus: Array<any> = [];
  protected matrimonialRegimes: Array<any> = [];
  protected departments: Array<any> = [];
  protected companyRoles: Array<any> = [];
  protected userRoles: Array<any> = [];

  protected mounted() {
    http.get('/auxiliary/marital-status')
      .then((results) => this.maritalStatus.push(...results.data))
      .catch((error) => console.log(error));

    this.matrimonialRegimes.push({ id: 0, description: 'Selecione um regime de partilha de bens...' });
    http.get('/auxiliary/matrimonial-regimes')
      .then((results) => this.matrimonialRegimes.push(...results.data))
      .catch((error) => console.log(error));

    this.departments.push({ id: 0, description: 'Selecione um departamento...' });
    http.get('/auxiliary/departments')
      .then((results) => this.departments.push(...results.data))
      .catch((error) => console.log(error));

    this.companyRoles.push({ id: 0, description: 'Selecione um papel...' });
    http.get('/auxiliary/company-roles')
      .then((results) => this.companyRoles.push(...results.data))
      .catch((error) => console.log(error));

    http.get('/auxiliary/roles')
      .then((results) => this.userRoles.push(...results.data))
      .catch((error) => console.log(error));

    if (!isNullOrUndefined(this.selectedEmployee)) {
      this.newEmployee.id = this.selectedEmployee.id;
      this.newEmployee.name = this.selectedEmployee.name;
      this.newEmployee.birthDate = new Date(this.selectedEmployee.birthDate)
        .toISOString()
        .slice(0, 10);
      this.newEmployee.cpf = this.selectedEmployee.cpf;
      this.newEmployee.rg = this.selectedEmployee.rg;
      this.newEmployee.maritalStatus = this.selectedEmployee.maritalStatus;
      this.newEmployee.matrimonialRegime = this.selectedEmployee.matrimonialRegime;
      this.newEmployee.department = this.selectedEmployee.department;
      this.newEmployee.companyRole = this.selectedEmployee.companyRole;
      this.newEmployee.user = {
        login: this.selectedEmployee.user.login,
        password: this.selectedEmployee.user.password,
        roles: [ ...this.selectedEmployee.user.roles.map((role: any) => role.id) ],
      };
    }
  }

  protected get activatorText(): string {
    return (isNullOrUndefined(this.selectedEmployee) ? 'Adicionar' : 'Editar');
  }

  @Emit('newEmployee')
  protected async save() {
    if (!isNullOrUndefined(this.selectedEmployee)) {
      await http.put(`/companies/${this.$route.params.id}/employees`, {
        employee: {
          id: this.newEmployee.id,
          name: this.newEmployee.name,
          cpf: this.newEmployee.cpf,
          rg: this.newEmployee.rg,
          birthDate: new Date(this.newEmployee.birthDate),
          maritalStatus: this.newEmployee.maritalStatus,
          matrimonialRegime: this.newEmployee.matrimonialRegime,
          department: this.newEmployee.department,
          companyRole: this.newEmployee.companyRole,
          user: {
            login: this.newEmployee.user.login,
            password: this.newEmployee.user.password,
            roles: [ ...this.newEmployee.user.roles ],
          },
        },
      });
      this.isShowing = false;
      return true;
    } else {
      let dbNaturalPerson;
      let dbEmployee;
      dbNaturalPerson = await http.post('/person/natural', {
        name: this.newEmployee.name,
        birthDate: new Date(this.newEmployee.birthDate),
        cpf: this.newEmployee.cpf,
        rg: this.newEmployee.rg,
        maritalStatusId: this.newEmployee.maritalStatus,
        matrimonialRegimeId: this.newEmployee.matrimonialRegime !== 0 ?
          this.newEmployee.matrimonialRegime :
          null,
      });
      dbEmployee = await http.post(`/companies/${this.$route.params.id}/employees`,
        {
          personId: dbNaturalPerson.data.person,
          companyId: this.$route.params.id,
          departmentId: this.newEmployee.department,
          companyRoleId: this.newEmployee.companyRole,
        },
      );
      await http.post('/users', {
        employeeId: dbEmployee.data.id,
        roleIds: this.newEmployee.user.roles,
        login: this.newEmployee.user.login,
        password: this.newEmployee.user.password,
      });
      this.isShowing = false;
      this.newEmployee = {
        name: '',
          birthDate: new Date(Date.now()).toISOString().slice(0, 10),
        cpf: '',
        rg: '',
        maritalStatus: 2,
        matrimonialRegime: 0,
        department: 0,
        companyRole: 0,
        user: {
        login: '',
          password: '',
          roles: [],
        },
      };
      return true;
    }
  }
}
